import { IFieldType, IFormSchema, IAutocomplete } from "shared/types";
import { copy } from "shared/assets";

const { errors, authFormFields, changeEmail } = copy;

export const makeSchema = (oldEmail: string, handleClose: () => void): IFormSchema => ({
  fields: [
    {
      name: "email",
      label: authFormFields.newEmail,
      type: IFieldType.email,
      autocomplete: IAutocomplete.email,
      validation: {
        required: errors.required,
        validate: {
          value: (newEmail: string) =>
            oldEmail === newEmail ? changeEmail.errors.differentEmail : true,
        },
      },
    },
  ],
  buttons: {
    primary: {
      children: copy.changeEmail.button,
      "data-testid": "change_email_confirm",
    },
    secondary: {
      onClick: handleClose,
      "data-testid": "change_email_cancel",
    },
  },
});
